import day from 'dayjs'

import { BlogPost, BlogPosts } from '../interfaces/blog'

export const getReadTime = (numOfWords: number): string => {
  const wordsPerMinute = 265
  const duration = Math.ceil(numOfWords / wordsPerMinute)
  return `${duration} ${duration > 1 ? 'mins' : 'min'} read`
}

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const uncapitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

export const getMappedBlogPosts = (blogPosts: BlogPosts, withSort: boolean = true) => {
  return blogPosts.edges
    .sort((a, b) =>
      withSort
        ? day(b.node.publishedAt || b.node.createdAt)
            .toDate()
            .getTime() -
          day(a.node.publishedAt || a.node.createdAt)
            .toDate()
            .getTime()
        : 0
    )
    .map((post) => {
      return {
        ...post.node,
        abstract: post.node.abstract?.abstract,
      }
    })
}

export const getMappedCategoryBlogPosts = (blogPosts: BlogPost[], withSort: boolean = true) => {
  return blogPosts
    .sort((a, b) =>
      withSort
        ? day(b.publishedAt || b.createdAt)
            .toDate()
            .getTime() -
          day(a.publishedAt || a.createdAt)
            .toDate()
            .getTime()
        : 0
    )
    .map((post) => {
      return {
        ...post,
        abstract: post.abstract?.abstract,
      }
    })
}
